module.exports = __webpack_public_path__ + "img/trump-logo.674cd7cf.png";